import { render, staticRenderFns } from "./SDABottomBar.vue?vue&type=template&id=27cacf38&scoped=true"
import script from "./SDABottomBar.vue?vue&type=script&lang=js"
export * from "./SDABottomBar.vue?vue&type=script&lang=js"
import style0 from "./SDABottomBar.vue?vue&type=style&index=0&id=27cacf38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cacf38",
  null
  
)

export default component.exports